import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildWatchtower: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const size = 5;
    const platformY = 4;
    const posts: [number, number][] = [
        [0, 0],
        [size - 1, 0],
        [0, size - 1],
        [size - 1, size - 1],
    ];

    for (const [dx, dz] of posts) {
        brush.column(dx, dz, 0, 5, BLOCK.StructureLog);
    }
    brush.layer(0, size - 1, 0, size - 1, platformY, BLOCK.Planks);
    brush.lineX(0, 1, platformY + 1, 0, BLOCK.StructureLog);
    brush.lineX(3, 4, platformY + 1, 0, BLOCK.StructureLog);
    brush.lineX(0, size - 1, platformY + 1, size - 1, BLOCK.StructureLog);
    brush.lineZ(0, platformY + 1, 0, size - 1, BLOCK.StructureLog);
    brush.lineZ(size - 1, platformY + 1, 0, size - 1, BLOCK.StructureLog);

    const roofY = platformY + 3;
    brush.layer(-1, size, -1, size, roofY, BLOCK.Thatch);
    brush.layer(1, size - 2, 1, size - 2, roofY + 1, BLOCK.Thatch);
};
